<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import { devices } from 'src/stores/lists/devices';
	import ControlPreview from 'src/components/TemperatureScheme/TempSchemeDrawSections/ControlPreview.svelte';

	export let id: string;
	export let units: string;
	export let thermostatDefTemp: number;
	export let type: string;
	export let deviceSensorId: string;
	export let deviceSensorIsOnline: boolean;
	export let extTempSensor: any;
	export let extTempSensorValue: any;

	// Accept unused props forwarded from parent without Svelte warnings
	export let actuators;
	export let deviceSensor;
</script>

<SidepanelContent>
	<ControlPreview
		{id}
		{units}
		{thermostatDefTemp}
		{type}
		showType
		extSensorValue={extTempSensorValue}
		sensorIsOnline={Boolean(deviceSensorIsOnline)}
		extSensor={extTempSensor || {
			id: deviceSensorId,
			deleted: true,
			name: $devices[deviceSensorId]?.name || '',
		}}
	/>
</SidepanelContent>
